import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["fonts--site-font", "site-preview", "clear-input"];

  resetFonts() {
    const alert_message = "Are you sure you want to reset Site Fonts? This action will reset all font styles to default and remove all font customization."
    const dialog = $(
      `<div id='dialog-confirm' role='alert'><p>${alert_message}</p></div>`
    );

    if (!$("#dialog-confirm").length) $("body").append(dialog);

    dialog.dialog({
      dialogClass: 'reset_confirmation_modal',
      resizable: false,
      modal: true,
      title: 'Reset Site Fonts',
      buttons: {
        Cancel: function(){ dialog.dialog('close') },
        Reset: function(){
          dialog.dialog('close');
          this.#resetSiteFont();
          this.#resetPersistentValues();
          this.clearInputOutlet.clear();
          this.fontsSiteFontOutlet.setSiteFontsPreview();
          this.fontsSiteFontOutlet.hideResetSiteLink();
          this.fontsSiteFontOutlet.removeFontsPreviewStyles();
          this.fontsSiteFontOutlet.headingStyleTarget.classList.add('hidden');
         }.bind(this),
      }
    });
  }

  #resetSiteFont() {
    const siteId = this.sitePreviewOutlet.siteId();

    this.fontsSiteFontOutlet.resetDefaultFontPairing();

    this.fontsSiteFontOutlet.fetcher({
      url: `/sites/${siteId}/reset_site_font`,
      onSuccess: () => {
        this.sitePreviewOutlet.sync();
        app.view_panel.notify("The default fonts has been restored.");
      }
    });
  }

  #resetPersistentValues() {
    $("#persistent_font_pairing_id").val("");
    $("#persistent_heading_font_id").val("");
    $("#persistent_body_font_id").val("");
    $("#persistent_heading_font_weight_style").val("Normal");
    $("#persistent_heading_font_case_style").val("");
  }
}
